// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + ".js";
};